import { render, staticRenderFns } from "./CreateWorkOrder.vue?vue&type=template&id=66626229&"
import script from "./CreateWorkOrder.vue?vue&type=script&lang=ts&"
export * from "./CreateWorkOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66626229')) {
      api.createRecord('66626229', component.options)
    } else {
      api.reload('66626229', component.options)
    }
    module.hot.accept("./CreateWorkOrder.vue?vue&type=template&id=66626229&", function () {
      api.rerender('66626229', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/sparepart-request/CreateWorkOrder.vue"
export default component.exports